<!-- Generic Text Field -->
<template>
  <div>
    
    <v-row style="align-items: center;">
      <v-col cols="12" md="12" sm="12"> 
        <div class="input-helper">
          <div class="element"> 
            <v-textarea
              class="textInput"
              v-model="cmpValue"
              type="text"
              :maxlength="$attrs.maxlength"
              :counter="$attrs.maxlength ? $attrs.maxlength : undefined"
              v-bind="$attrs"
              v-on="$listeners"
              :label="cmpLabel"
              :rules="rules"
              @input="_input"
              @blur="_input"
              @change="_input"
              @keypress="_keyPress">

              <template slot="append" v-if="!$attrs.disabled">
                <v-btn x-small fab class="cleanBtn" 
                  elevation="0"
                  tabindex="-1"
                  v-if="cmpValue != null && cmpValue != ''" 
                  @click="_clear">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-textarea>
          </div>
          <div class="flex-btn"> 
            <v-btn x-small fab class="helperBtn" v-if="!!helperText"
              elevation="0"
              tabindex="-1"
              @click="_showHelperText">
              <v-icon>mdi-help</v-icon>
            </v-btn>
          </div>  
        </div>
      </v-col>
    </v-row>

    <HelperDialog
      :helperText="helperText"
      :show="helperTextPopUpVisible"
      @close="_closeHelperText">
    </HelperDialog>

  </div>
</template>

<script>

  import HelperDialog from "./helper-dialog.vue"
  import regExpressions from "@/shared/constants/regexpressions.js";
  import generic from '@/shared/utils/generic.js';

  export default {
    name: 'TextArea',
    inheritAttrs: false,
    components: {
      HelperDialog
    },
    props: {
      label: { type: String },
      rules: { type: Array },
      value: { type: String },
      helperText: { type: String },
    },
    emits: ["input", "clear"],
    data: () => ({
      helperTextPopUpVisible: false,
      isRequired: undefined,
    }),
    created() {
      this.isRequired = generic.isRequired(this.rules);
    },    
    methods: {
      _clear() { 
        this.cmpValue = '';
        this.$emit("clear"); 
      },

      _input() { 
        // Trim content to prevent white spaces as content
        this.cmpValue = this.value != null && this.value.trim ? this.value.trim() : this.value;
        this.$emit("input", this.cmpValue); 
      },
      
      _keyPress($event) {
        if (!regExpressions.GenericTexts.test($event.key)) $event.preventDefault();
      },

      _showHelperText () { 
        this.helperTextPopUpVisible = !!this.helperText;
      },

      _closeHelperText() { 
        this.helperTextPopUpVisible = false;  
      },
    },

    computed: {
      cmpValue: {
        get: function () { return this.value; },
        set: function (newValue) { this.$emit("input", newValue); },
      },
      cmpLabel: {
        get() { return this.label + (this.isRequired ? ' *' : '') },
      }
    },
  };
</script>

<style scoped>

</style>